if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('swiper-slide-active');
          element.classList.remove('swiper-slide-next');
          element.classList.remove('swiper-slide-prev');
          element.classList.remove('active');
        });
        this.querySelectorAll(
          `.thumbnail-slide`
        ).forEach((element) => {
          element.classList.remove('swiper-slide-thumb-active');
          element.classList.remove('swiper-slide-next');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeThumbnail = this.querySelector(`.thumbnail-slide[data-target="${this.openedBy.getAttribute('data-media-id')}"]`);
        const nextThumbnail = activeThumbnail.nextSibling;
        const nextMedia = activeMedia.nextSibling;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('swiper-slide-active');
        activeMedia.classList.add('active');
        activeMedia.classList.remove('swiper-slide-next');
        activeThumbnail.classList.add('swiper-slide-thumb-active');
        activeThumbnail.classList.remove('swiper-slide-next');
        nextThumbnail.classList.add('swiper-slide-next');
        nextMedia.classList.add('swiper-slide-next');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
